import { renderLifecycleHookImportContentTemplate } from '@next-adapter/templates/renderers/generators/actions/lifecycle-hook-emissions/lifecycle-hook-import.js'
export function lifecycleHookImport(): string {
  return renderLifecycleHookImportContentTemplate()
}
